import BasicBlueprint from 'components/Icons/BasicBlueprint';
import Camera from 'components/Icons/Camera';
import DiscussionSpeechBubble from 'components/Icons/DiscussionSpeechBubble';
import Document from 'components/Icons/Document';
import ThinCross from 'components/Icons/ThinCross';
import React from 'react';
import { RFIAttachmentTypes } from 'records/RFIAttachment';

interface Props {
  type: RFIAttachmentTypes;
  text: string;
  onRemove: () => void;
}

/*
.bmp = image/bmp
.jpg, .jpeg = image/jpeg
.svg = image/svg+xml
.gif = image/gif
.png = image/png
*/

type FileTypeIconMap = {
  [key in RFIAttachmentTypes]: React.ReactNode;
};

const fileTypeIconMap: FileTypeIconMap = {
  [RFIAttachmentTypes.FILE]: <Document />,
  [RFIAttachmentTypes.IMAGE]: <Camera />,
  [RFIAttachmentTypes.DRAWING]: <BasicBlueprint width="14px" height="14px" />,
  [RFIAttachmentTypes.MARKUP]: <Document />, // No markup asset yet.
  [RFIAttachmentTypes.DISCUSSION]: (
    <DiscussionSpeechBubble width="20px" height="20px" />
  ),
};

const RFIFilesListItem: React.FC<Props> = ({ text, type, onRemove }) => {
  return (
    <div
      className="row justify-between items-center bb-2 bgd-white"
      style={{ height: '44px' }}
    >
      <div className="row items-center mx3 fill-gray-6">
        <span className="wrem-1 hrem-1 flex-center">
          {fileTypeIconMap[type]}
        </span>
      </div>
      <div className="grow-1">{text}</div>
      <div className="cursor-pointer mx3" onClick={(): void => onRemove()}>
        <ThinCross width="10px" />
      </div>
    </div>
  );
};

export default RFIFilesListItem;
